import type { BlogPost } from "@/hooks/useSiteContent";

/** Gera um slug amigável a partir do título (usado quando o admin não define um). */
export function slugify(value: string) {
  return value
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
}

export function postSlug(post: BlogPost) {
  return (post.slug || "").trim() || slugify(post.title || "post");
}

export function findPost(posts: BlogPost[], slug: string) {
  return posts.find((p) => postSlug(p) === slug);
}

/** Texto puro de um trecho vindo do editor: remove tags e converte entidades (&nbsp;, &amp;...). */
export function plainText(value: string | undefined | null): string {
  if (!value) return "";
  const noTags = value.replace(/<[^>]*>/g, " ");
  const decoded =
    typeof document !== "undefined"
      ? (() => {
          const el = document.createElement("textarea");
          el.innerHTML = noTags;
          return el.value;
        })()
      : noTags.replace(/&nbsp;/gi, " ").replace(/&amp;/gi, "&");
  return decoded.replace(/[ \s]+/g, " ").trim();
}

/** Calcula o tempo estimado de leitura (base 200 palavras por minuto). */
export function estimateReadingTime(text: string): string {
  if (!text) return "2 min de leitura";
  const clean = text.replace(/<[^>]*>/g, " ");
  const words = clean.trim().split(/\s+/).filter(Boolean).length;
  const minutes = Math.max(1, Math.ceil(words / 200));
  return `${minutes} min de leitura`;
}

/** Quebra o corpo do post em parágrafos para compatibilidade com posts antigos sem HTML. */
export function postParagraphs(post: BlogPost) {
  const body = (post.body || "").trim() || post.excerpt || "";
  return body
    .split(/\n{1,}/)
    .map((p) => p.trim())
    .filter(Boolean);
}
